// 撮影例モーダルの開閉制御
window.addEventListener('load', () => {
  const modal = document.getElementById('photo-example-modal');
  if (!modal) return;

  // bodyスクロールをロック（現在のスクロール位置を保持）
  // body.style.overflow = hidden だけだとブラウザ依存でスクロール位置がリセットされるため、
  // position: fixed + top: -scrollY で位置を固定してロックし、解除時に戻す
  let savedScrollY = 0;
  const lockBodyScroll = () => {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };
  const unlockBodyScroll = () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, savedScrollY);
  };

  // a11y: モーダル開閉時に focus を適切に移動する
  // - open: モーダル内の閉じるボタンに移動（スクリーンリーダーにダイアログ内部を認識させる）
  // - close: モーダルを開いたトリガー要素に戻す（フォーカスロストを防ぐ）
  let lastFocusedElement = null;
  const closeBtn = modal.querySelector('.photo-example-modal-close');

  const openModal = () => {
    lastFocusedElement = document.activeElement;
    modal.classList.remove('hidden');
    lockBodyScroll();
    closeBtn?.focus();
  };
  const closeModal = () => {
    modal.classList.add('hidden');
    unlockBodyScroll();
    lastFocusedElement?.focus?.();
  };

  // 「撮影例はこちら」リンクでモーダルを開く
  document.querySelectorAll('.photo-example-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  // 閉じるボタン
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // オーバーレイクリックで閉じる
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // Escキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
  });
});
